export enum EOfferType {
	general,
	special
}